<template>
    <div v-if="loading" class="flex flex-column justify-content-center align-items-center">
        <h4 class="text-center">Loading...</h4>
        <ScaleLoader class="m-auto" />
    </div>

    <div v-if="!loading" class="card">
        <div class="grid">
            <div class="form-field col-3">
                <label for="name">User Group Name</label>
                <span id="name">{{userGroupModel.name}}</span>
            </div>
            <div class="form-field col-3">
                <label for="code">Code</label>
                <span id="code">{{userGroupModel.code}}</span>
            </div>
            <div class="form-field col-6">
                <label for="description">Description</label>
                <span id="description">{{userGroupModel.description}}</span>
            </div>

            <div class="col-12">
                <div class="flex justify-content-end">
                    <Button label="Cancel" icon="pi pi-times" class="p-button-danger" @click="onCancel" />
                </div>
            </div>
        </div>

    </div>
    <div v-if="!loading"  class="card">
        <h5 class="text-center">
            Linked Datasource:
        </h5>
        <div class="grid">
            <div class="form-field col-2">
                <b>Code:</b>
            </div>
            <div class="form-field col-4">
                {{ datasource.code }}
            </div>
            <div class="form-field col-2">
                <b>Name:</b>
            </div>
            <div class="form-field col-4">
                {{ datasource.name }}
            </div>
            <div class="form-field col-2">
                <b>Description:</b>
            </div>
            <div class="form-field col-10">
                {{ datasource.description }}
            </div>
        </div>
        <divider/>
        <DataTable :value="users" :paginator="true" :rows="5" responsiveLayout="scroll">
            <template #empty> No Users available </template>
            <Column field="id" header="ID" />
            <Column field="name" header="Name" />
            <Column field="surname" header="Surname" />
        </DataTable>
        <divider/>
        <p>
            The linked Datasource cannot be amended. In case that it need to be changed, please delete this
            UserGroup and re-create it from scratch using the right Datasource.
        </p>

    </div>
</template>

<script setup>
import { computed, defineProps, onBeforeMount, ref } from 'vue';
import GlobalRequest from '@/api/global-request';
import store from '@/store';
import { useRouter } from 'vue-router';

const router = useRouter();

const loading = ref(true);

const props = defineProps({
    id: {
        type: [String, Number],
        required: false,
    }
});

const company_id = computed(() => {
    return store.getters['auth/userCompanyId']?.id;
});

const userGroupModel = ref({
    company_id: null,
    name: null,
    code: null,
    description: null,
    id: null,
    datasource_id: null,
})

const datasource = ref({
    id: null,
    code: null,
    name: null,
})

const users = ref([]);

function onCancel() {
    router.go(-1)
}

const loadUserGroupDetails = async (userGroupId) => {
    loading.value = true;

    GlobalRequest.getRequest('/v2/datasource/users/'+userGroupId, {
        params: {
            company_id: company_id.value,
        },
    }).then((response) => {
        if (response.statusCode === 200) {
            userGroupModel.value.company_id = response.data.userGroup.company_id;
            userGroupModel.value.name = response.data.userGroup.name;
            userGroupModel.value.code = response.data.userGroup.code;
            userGroupModel.value.description = response.data.userGroup.description;
            userGroupModel.value.id = response.data.userGroup.id;
            userGroupModel.value.datasource_id = response.data.userGroup.datasource_id;

            datasource.value.id = response.data.datasource_id;
            datasource.value.code = response.data.userGroup.datasource.code;
            datasource.value.name = response.data.userGroup.datasource.name;
            datasource.value.description = response.data.userGroup.datasource.description;

            users.value = response.data.users;

            loading.value = false;
        }
    });

}

onBeforeMount(async () => {
    if (props.id !== undefined) {
        await loadUserGroupDetails(props.id);
    } else {
        loading.value = false;
    }

});

</script>

<style lang="scss" scoped>
.form-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.5rem;
}

.form-field label {
    margin-bottom: 0.5rem;
}
</style>